/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

export const portalAdvices = (params) => {
    return request({
        url: '/api-otp/portalAdvice/portalAdvices',
        method: 'post',
        data: params
    });
};

export default {
    portalAdvices
};